import { Descriptions, Divider } from "antd";
import CommonOverlayComponent from "commons/CommonOverlayComponent";
import { CommonFormFields } from "commons/Forms/formsComponents/formTypes";
import CommonCard from "commons/Layout/CommonCard";
import { AuthContext } from "context/auth";

import "ol/ol.css";
import { useContext, useState } from "react";
import { FormatUnixDate } from "utils/helpers/date_helpers";

const Profile = () => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const { currentUser } = useContext(AuthContext);

    const FormFields: CommonFormFields[] = [
        {
            name: "name",
            label: "Nome progetto",
            type: "string",
            span: 12,
        },
        {
            type: "select",
            label: "Tipo di suolo",
            name: "soil_texture",
            span: 12,
            options: [
                { label: "Sabbioso", value: 1 },
                { label: "Limoso", value: 2 },
                { label: "Argilloso", value: 3 },
                { label: "Altro", value: 4 },
            ],
            // conditions: {
            //     visibleIf: {
            //         name: 'documento',
            //         value: true,
            //     },
            // },
        },
        {
            type: "date",
            name: "simulation_start_date",
            label: "Data inizio simulazione",
            format: "DD/MM/YYYY",
            span: 12,
        },
        {
            type: "date",
            name: "simulation_end_date",
            label: "Data fine simulazione",
            format: "DD/MM/YYYY",
            span: 12,
        },
        {
            type: "radio",
            label: "Irrigazione",
            name: "irrigation",
            showAsButtons: true,
            options: [
                { label: "Si", value: true },
                { label: "No", value: false },
            ],
            span: 12,
        },
        {
            name: "note",
            label: "Note",
            type: "textarea",
        },
    ];

    return (
        <CommonCard title={<h2>Profilo Utente</h2>}>
            <Descriptions
                bordered
                column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
            >
                <Descriptions.Item label="Username">
                    {currentUser?.username}
                </Descriptions.Item>
                <Descriptions.Item label="Email">
                    {currentUser?.email}
                </Descriptions.Item>
                <Descriptions.Item label="Data Creazione">
                    {FormatUnixDate(currentUser?.created_at)}
                </Descriptions.Item>
            </Descriptions>

            <Divider></Divider>
            {/* <Button type="primary" onClick={() => setDrawerVisible(true)}>
                Modifica
            </Button> */}

            {/* <CommonFormAnt fields={FormFields}/> */}
            <CommonOverlayComponent
                title={"Modifica profilo"}
                // onSubmit={onSubmit}
                type="drawer"
                destroyOnClose={true}
                //permission={DisabledFields}
                visible={drawerVisible}
                width={"60%"}
                okText="Conferma e Salva"
                onCancel={() => setDrawerVisible(false)}
                formsOpts={{
                    debug: false,
                    fields: FormFields,
                    //ref: Form,
                    hideSubmit: true,
                    initialValues: undefined,
                }}
            />
        </CommonCard>
    );
};

export default Profile;
